import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { H2Atom } from '@atoms/text-atoms/text-atoms';
import { HorizontalTableProps } from './horizontal-table.types';

const HorizontalTable: React.FC<HorizontalTableProps> = ({
  title,
  children,
  className,
  isVisible = true,
}) => {
  if (isVisible && children) {
    let filteredChildren;
    if (Array.isArray(children)) {
      /* If multiple children come through, filter out any null children... */
      filteredChildren = children.filter(child => child != null);
    } else {
      /* ... otherwise just re-assign the single child */
      filteredChildren = children;
    }

    if (filteredChildren) {
      return (
        <div className={className} data-testid="horizontal-table">
          {title && <H2Atom>{title}</H2Atom>}
          <div className="table-container">{filteredChildren}</div>
        </div>
      );
    } else {
      console.warn(
        `HorizontalTable filteredChildren not valid: ${filteredChildren}`
      );
      return null;
    }
  } else return null;
};

const StyledHorizontalTable = styled(HorizontalTable)`
  width: 100%;
  padding: ${vars.spacingM} 0;
  ${H2Atom} {
    padding-bottom: 1rem;
    ${vars.fontSize8}
    color: ${vars.coreDarkGrey};
  }
  .table-container {
    padding: 0;
  }
`;

export default StyledHorizontalTable;
